import { render, staticRenderFns } from "./NuevosIngresos.vue?vue&type=template&id=cf3eca88&scoped=true"
import script from "./NuevosIngresos.vue?vue&type=script&lang=js"
export * from "./NuevosIngresos.vue?vue&type=script&lang=js"
import style0 from "./NuevosIngresos.vue?vue&type=style&index=0&id=cf3eca88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3eca88",
  null
  
)

export default component.exports